import React from 'react'
import PropTypes from 'prop-types';

import styles from "./label.scss";

function Label(props) {

    const {labelName, labelClass} = props;

    return (
        <label className={labelClass}>{labelName}</label>
    )
}

Label.defaultProps = { 
    labelClass: styles.label
}

Label.propTypes = {
    labelName: PropTypes.string.isRequired,
    labelClass: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ])
}

export default Label
